import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { SelectedCustomer, UserService } from './user.service';
import { IntegratorService } from './integrator.service';
import { AppinfoService } from './appinfo.service';
import { LayerService } from './layer.service';

@Injectable({
  providedIn: 'root'
})
export class ResolverGiveInitService implements Resolve<any> {

	constructor(
		private appinfoService: AppinfoService,
		private integratorService: IntegratorService,
		private layerService: LayerService,
		private userService: UserService
	) { }

	async resolve() {
		await this.resolveInit();
		await this.resolveSelectedCustomer();
		await this.resolveLayers();
	}
	private async resolveInit() {
		await this.appinfoService.getAppinfo();
		const cusId = this.userService.getUserInfo().customerId;
		await this.appinfoService.getAppinfoByCustomer(cusId);
		return;
	}
	private async resolveSelectedCustomer() {
		let selectedCustomer = this.userService.selectedCustomer.getValue();
		// Get selectedCustomer from local storage
		if (!selectedCustomer && this.userService.customerInfo) {
			const storedSelectedCustomerStr = localStorage.getItem(this.userService.selectedCustomerItemName);
			if (storedSelectedCustomerStr) {
				let storedSelectedCustomer: SelectedCustomer = JSON.parse(storedSelectedCustomerStr);
				switch (this.userService.customerInfo.type) {
					case 'integrator':
						if (!this.userService.clients) {
							await this.integratorService.getIntegratorClients();
						}
						// Check if stored customer is in the client list
						const client = this.userService.clients.find((c) => c.cusId === storedSelectedCustomer.id);
						if (client) {
							selectedCustomer = {
								id: client.cusId,
								nameShort: client.cusNameShort,
								adminEmails: client.adminEmails
							};
						}
						break;
					default:
						// this.userService.customerInfo.children.find((c) => c.id === storedSelectedCustomer.id);
						// Not sure if this is needed for end user
						break;
				}
			}
		}
		// Get selectedCustomer from existing list
		if (!selectedCustomer && this.userService.customerInfo) {
			switch (this.userService.customerInfo.type) {
				case 'integrator':
					if (!this.userService.clients) {
						await this.integratorService.getIntegratorClients();
					}
					if (this.userService.clients[0] && this.userService.clients[0].cusId) {
						selectedCustomer = {
							id: this.userService.clients[0].cusId,
							nameShort: this.userService.clients[0].cusNameShort,
							adminEmails: this.userService.clients[0].adminEmails
						};
					}
					break;
				default:
					selectedCustomer = {
						nameShort: this.userService.customerInfo.nameShort,
						id: this.userService.customerInfo.id,
						adminEmails: this.userService.customerInfo.adminEmails
					};
			}
		}
		console.log('selectedCustomer', selectedCustomer)
		this.userService.selectedCustomer.next(selectedCustomer);
		return selectedCustomer;
	}
	private async resolveLayers() {
		const layers = await this.layerService.getLayers();
		// resolve bdry layers too
		await this.layerService.getBdryLayers();

		return layers;
	}
}
